module.exports = __webpack_public_path__ + "static/media/monitor-top.bdfc528e.png";